import { Box, Typography, Grid, InputLabel, Select, MenuItem, Autocomplete, TextField, Button } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { useState, useEffect } from 'react'
import moment from 'moment'
import 'moment/locale/es'
import { useTaskContext } from '../../../shared/context/taskContext'
import { useRrhh } from '../../../shared/context/rrhhContext'
import { useAuth } from '../../../shared/context/authContext'
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from '@mui/material/CircularProgress';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import {
    getDefaultKanbanFilters,
    kanbanFiltersToSearchParams,
    saveKanbanFiltersToStorage,
} from '../utils/kanbanFilters'

export default function FiltersKanbanComponent({ setSearchParams }) {
    const { filtersKanban, setFiltersKanban, loadingTasks, getTasksMonthExcel, loadingTasksMonthExcel } = useTaskContext()
    const { rrhhByName, loadingGetRrhhByName, getRrhhByName } = useRrhh()
    const { authUser } = useAuth()

    useEffect(() => {
        moment.locale('es')
        if (filtersKanban.responsible?.id) {
            getRrhhByName({ user_task_attender: true })
        }
    }, [])

    const handleStartDateChange = (date) => {
        if (!date) {
            setFiltersKanban(prev => ({ ...prev, startDate: null }))
            return
        }
        setFiltersKanban(prev => ({
            ...prev,
            startDate: moment(date)
        }))
    }

    const handleEndDateChange = (date) => {
        if (!date) {
            setFiltersKanban(prev => ({ ...prev, endDate: null }))
            return
        }
        setFiltersKanban(prev => ({
            ...prev,
            endDate: moment(date)
        }))
    }

    const handleApplyFilters = () => {
        const params = kanbanFiltersToSearchParams(filtersKanban)
        setSearchParams(params, { replace: true })
        saveKanbanFiltersToStorage(params)
    }

    const handleClearFilters = () => {
        const resetFilters = getDefaultKanbanFilters()
        setFiltersKanban(resetFilters)
        const params = kanbanFiltersToSearchParams(resetFilters)
        setSearchParams(params, { replace: true })
        saveKanbanFiltersToStorage(params)
    }

    return (
        <Box sx={{p:2}}>
            <Grid container spacing={2}>
                <Grid item size={{xs:12}}>
                    <InputLabel>Fecha inicial</InputLabel>
                    <DatePicker 
                        value={filtersKanban.startDate || null}
                        onChange={handleStartDateChange}
                        maxDate={filtersKanban.endDate || null}
                        format="DD/MM/YYYY"
                        slotProps={{
                            textField: {
                                fullWidth: true
                            }
                        }}
                    />
                </Grid>
                <Grid item size={{xs:12}}>
                    <InputLabel>Fecha final</InputLabel>
                    <DatePicker 
                        value={filtersKanban.endDate || null}
                        onChange={handleEndDateChange}
                        minDate={filtersKanban.startDate || null}
                        format="DD/MM/YYYY"
                        slotProps={{
                            textField: {
                                fullWidth: true
                            }
                        }}
                    />
                </Grid>

               {authUser.role.user_task_manager  && <Grid item size={{xs:12}}>
                    <InputLabel>Responsable de OT</InputLabel>
                    <Autocomplete
                        fullWidth
                        options={rrhhByName}
                        renderInput={(params) => <TextField {...params} />}
                        onChange={(event, newValue) => {
                            setFiltersKanban(prev => ({ ...prev, responsible: newValue }))
                        }}
                        onOpen={() => getRrhhByName({ user_task_attender: true })}
                        getOptionLabel={(option) => option?.fullName ? `${option.fullName} ` : ''}
                        isOptionEqualToValue={(option, value) => {
                            if (!option || !value) return option === value;
                            return option.id === value.id;
                        }}
                        loading={loadingGetRrhhByName}
                        onInputChange={(event, newValue) => {
                            getRrhhByName({ name: newValue, user_task_attender: true })
                        }}
                        value={filtersKanban.responsible}
                        key={filtersKanban.responsible ? filtersKanban.responsible.id : 'no-responsible'}
                    />
                </Grid>}

                <Grid item size={{xs:12}}>
                    <InputLabel>Buscar OT por palabra clave o número</InputLabel>
                    <TextField
                        value={filtersKanban.numberOt || ''}
                        onChange={(e) => setFiltersKanban(prev => ({ ...prev, numberOt: e.target.value }))}
                        placeholder="Número, activo, tarea, responsable..."
                        fullWidth
                    />
                </Grid>

                <Grid item size={{xs:12}}>
                    <InputLabel>Buscar por descripcion de la tarea</InputLabel>
                    <TextField
                        value={filtersKanban.description || ''}
                        onChange={(e) => setFiltersKanban(prev => ({ ...prev, description: e.target.value }))}
                        fullWidth
                    />
                </Grid>


                <Grid item size={{xs:12}}>
                    <InputLabel>Filtrar por tipo de tarea</InputLabel>
                    <Select fullWidth value={filtersKanban.taskType || 'all'} onChange={(e) => setFiltersKanban(prev => ({ ...prev, taskType: e.target.value }))}>
                        <MenuItem value="all">Todas</MenuItem>
                        <MenuItem value="scheduled">Programada</MenuItem>
                        <MenuItem value="unscheduled">No programada</MenuItem>
                    </Select>
                </Grid>


                
                <Grid item size={{xs:12}} sx={{display: 'flex', gap: 2}}>
                    <Button startIcon={ loadingTasks ? <CircularProgress size={20} /> : <FilterListIcon />} disabled={loadingTasks || filtersKanban.startDate === null || filtersKanban.endDate === null } variant="contained" color="primary" onClick={handleApplyFilters}>
                        Aplicar filtros</Button>
                    <Button startIcon={ loadingTasks ? <CircularProgress size={20} /> : <ClearIcon />} variant="contained" color="disabled" onClick={handleClearFilters}>Limpiar filtros</Button>
                </Grid>

                <Grid item size={{xs:12}}>
                    <Button variant="outlined" color="primary" fullWidth startIcon={ loadingTasksMonthExcel ? <CircularProgress size={20} /> : <FileDownloadIcon />} onClick={getTasksMonthExcel}>Descargar tareas</Button>
                </Grid>
            </Grid>
        </Box>
    )
}
